import PropTypes from 'prop-types';
import classNames from 'classnames';
import parse from 'html-react-parser';
import { Typography, makeStyles } from '@material-ui/core';
import {
  ellipsis,
  richTextContentStyles,
} from '../../../constants/helperCssRules';

const useStyles = makeStyles(theme => ({
  main: {
    ...richTextContentStyles(theme),
  },
  ellipsis: {
    ...ellipsis(),
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    '& > *': {
      margin: 0,
    },
    whiteSpace: 'normal',
  },
}));

const RichTextPreview = ({
  className = null,
  text = '',
  isEllipsis = false,
  variant = 'body2',
}) => {
  const classes = useStyles();

  return (
    <Typography
      className={classNames(
        classes.main,
        { [classes.ellipsis]: isEllipsis },
        className
      )}
      variant={variant}
      component="div"
    >
      {parse(text)}
    </Typography>
  );
};

RichTextPreview.propTypes = {
  className: PropTypes.string,
  isEllipsis: PropTypes.bool,
  text: PropTypes.string,
  variant: PropTypes.string,
};

export default RichTextPreview;
